import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/tokens.css';
import './index.css';
import App from './App';

document.addEventListener('wheel', function(e) {
  if (document.activeElement.type === 'number') {
    document.activeElement.blur();
  }
}, { passive: false });

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register service worker for PWA / offline support — production builds only.
// sw.js serves /static/js/bundle.js stale-while-revalidate, so on the dev
// server it hands the page the PREVIOUS bundle after every code change, and a
// registration left behind on localhost:3000 outlives the app that made it.
// In development any existing registration is removed instead, so a stale
// worker heals itself on the next load. (The public site runs on 3001 for the
// same reason: see alfresco-grand-web/CLAUDE.md.)
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    if (process.env.NODE_ENV === 'production') {
      navigator.serviceWorker
        .register('/sw.js')
        .then((reg) => console.log('[SW] Registered', reg.scope))
        .catch((err) => console.error('[SW] Registration failed', err));
    } else {
      navigator.serviceWorker.getRegistrations()
        .then((regs) => Promise.all(regs.map((r) => r.unregister())))
        .then((done) => { if (done.length) console.log('[SW] Unregistered on dev server'); })
        .catch(() => {});
    }
  });
}
